import { ComponentProps } from "react";
import { CutoffCountdown } from "./CutoffCountdown";
import { Cutoff, useCutoffCountdown } from "./useCutoffCountdown";

export const TrackedCutoffCountdown = ({
  cutoff,
  ...props
}: Omit<ComponentProps<typeof CutoffCountdown>, "timeLeft"> & {
  cutoff: Cutoff;
}) => {
  const timeLeft = useCutoffCountdown(cutoff);

  return <CutoffCountdown {...props} timeLeft={timeLeft} />;
};
